'use client'
import { submitEmailToList } from '@/lib/mailchimp'
import { useState } from 'react'
import { useToast } from '@/components/ui/use-toast'
import Image from 'next/image'

interface IProps {
  newsletterText?: string | null
}

export const NewsletterSignUp = ({ newsletterText }: IProps) => {
  const [email, setEmail] = useState('')
  const { toast } = useToast()

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (!email.includes('@')) return
    await submitEmailToList(email)
      .then((result) => {
        setEmail('')
        toast(result.toast)
      })
      .catch((err) => console.log('err', err))
  }

  return (
    <>
      <div className="flex w-auto justify-center">
        <div className=" justify-center flex-col gap-[15px] w-[317px] bg-[#202020] rounded-[13px] max-[768px]:w-[90vw] xl:h-[285px] items-center flex leading-[21.9px] p-[25px]">
          <span className="font-bold text-[22px] leading-[33px] w-[100%]">NEWSLETTER SIGN UP</span>
          <form onSubmit={handleSubmit} className="flex h-[56.89px] w-[100%]">
            <input
              id="newsletter-signup"
              className="text-black text-[14.6px] w-full rounded-tl-md rounded-bl-md px-[10px] border-0 focus:border-0 focus:outline-none h-full"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              aria-label="Email Address"
            />
            <button
              type="submit"
              className="bg-feYellow w-[50px] h-full flex justify-center rounded-tr-md rounded-br-md cursor-pointer items-center border-0"
            >
              <Image
                loading="eager"
                alt="arrow"
                width={14.8}
                height={70}
                style={{
                  width: '14.8px',
                  height: 'auto',
                }}
                src="/images/favicons/arrows-right.svg"
              />
            </button>
          </form>
          <p className="m-0 max-[1200px]:text-[15px] text-[17px] font-semibold ps-[6px] leading-[25.5px]">
            {newsletterText}
          </p>
        </div>
      </div>
    </>
  )
}
export default NewsletterSignUp
